export default [
  {
    path: '/admin/stock-adjustments',
    name: 'adjustment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/adjustment/index.vue')
  },
  {
    path: '/admin/stock-adjustments/create',
    name: 'adjustment-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/adjustment/create.vue')
  },
  {
    path: '/admin/stock-adjustments/:id/edit',
    name: 'adjustment-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/adjustment/edit.vue')
  }
]
